module.exports = __webpack_public_path__ + "img/ocultar.42d02acf.svg";